import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, LoadingController } from 'ionic-angular';
import { PatientAddPage } from '../patient-add/patient-add';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin';  
import 'rxjs/add/operator/mergeMap';
import * as moment from "moment";
import _ from 'lodash';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { PatientBatchPage } from '../patient-batch/patient-batch';
import { Storage } from '@ionic/storage';
import { OrderProvider } from '../../providers/order/order';
import { forkJoin, Subject } from 'rxjs';
import {OrderDetailsPage} from "../order-details/order-details";
import {UtilityProvider} from "../../providers/utility/utility";
import { PdfRxProvider } from "../../providers/pdf/pdf_rx";

@IonicPage()
@Component({
  selector: 'page-patient-details',
  templateUrl: 'patient-details.html',
})
export class PatientDetailsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  patient: any;
  fullname: string = null;
  insuranceImage: any = null;
  doctor: any;
  study: any;
  public patientStudy: Observable<any[]>;
  public patientDetails: Observable<any>;
  public prescriptions: any[];
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  group_name: string = null;
  clinic_order_number: string;
  clinic: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public alertCtrl: AlertController, 
    private database: DatabaseProvider,
    private utility: UtilityProvider,
    private auth: AuthProvider,
    public modalCtrl: ModalController,
    private storage: Storage,
    private orderService: OrderProvider,
    private toastCtrl: ToastController,
    private pdfRx: PdfRxProvider,
    private loadingCtrl: LoadingController,
  ) {
    this.patient = this.navParams.get('patient');
    this.fullname = this.patient['first_name'] + ' ' + this.patient['last_name'];
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;

      this.database.getClinic(this.clinic_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
          this.clinic_order_number = 'ORD' + this.utility.pad(this.clinic.current_order, 5, '0');
        }
      });
      
      this.database.getPatientFromClinic(this.clinic_id, this.patient.id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((patient) => {
        if(patient)  {
          patient['id'] = this.patient.id;
          this.patient = patient;
          this.patient.age = this.getAge(this.patient.dob);
        }
      });

      this.database.getClinic(this.clinic_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
        }
      });
      
      this.database.getPrescriptionsbyPatient(this.clinic_id, this.patient.id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      }).take(1)
        .subscribe((prescriptions) => {
          this.prescriptions = prescriptions.sort((a:any, b:any) => {
            return a.createdAt.seconds > b.createdAt.seconds ? -1 : 1;
          })
      });
    });

    this.orderService.updateBadge();
  }
  
  ngOnDestroy() {
    console.log('Leave patient details and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openPrescriptionImage(rx_id: string)  {
    this.database.getPrescription(rx_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((prescription: any) => {
        if (prescription) {
          window.open(prescription.prescription_image.url, '_blank');
        } else {
          this.toastCtrl.create({
            message: "This is an older prescription that does not have a corresponding pdf image.",
            duration: 4000
          }).present()
        }
      });
  }

  openOrderDetailsPage(order_id: any) {
    this.database.getOrder(order_id)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((order) => {
        this.navCtrl.push(OrderDetailsPage, {order: order});
      });
  }

  deletePatient() {
    let confirm = this.alertCtrl.create({
      title: "Delete Patient",
      message: "Are you sure you want to delete this patient?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't delete the patient right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            console.log("Delete patient: ", this.patient.id);
            const patient_id = this.patient.id;

            this.database.deletePatient(this.clinic_id, this.patient.id).then(() => {
              console.log("Delete patient success: ");
              const callback = this.navParams.get("deleteCallback");
              return callback(patient_id)
            }).then(() => {
              this.navCtrl.pop()
            })
            .catch((err) => {
              console.log("Delete patient error: ", err);
            })

          }
        }
      ]
    });
    confirm.present();
  }

  getAge(dateString) {
    console.log(dateString)
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

  editPatient() {
    this.navCtrl.push(PatientAddPage, {patient: this.patient, editCallback: this.navParams.get("editCallback")});
  }

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }
}


// WEBPACK FOOTER //
// ./src/pages/patient-details/patient-details.ts